import { FormHelperText, FormSelect } from 'components/form-fields';
import { ShowHide } from 'components/layout';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { EmployeeReviewsService } from 'services';
import './NewReviewModal.css';

const defaultArray = [];

const reviewTypeHeading = "Review Type";
const noReviewTypesMessage = "There are no review types available for this employee.";
const loadFailedMessage = "Could not load the review types for this employee. Please try again.";

// The review-type step of the new-review wizard: the types the chosen employee can be reviewed
// against, one of which the review will be raised for.
export function ReviewTypeStep(
    {
        selectedEmployeeId = null,
        selectedReviewTypeId = null,
        onSelectedReviewTypeChange
    }
) {
    const [reviewTypes, setReviewTypes] = useState(defaultArray);
    const [loading, setLoading] = useState(true);
    const [loadFailed, setLoadFailed] = useState(false);

    // The types a review can be raised against are the ones that apply to the chosen employee, so
    // they are read for that employee rather than taken from the account's own review types.
    useEffect(() => {
        if (selectedEmployeeId == null) {
            return;
        }

        setLoading(true);
        setLoadFailed(false);

        EmployeeReviewsService.getAvailableReviewTypes(selectedEmployeeId).then(
            (availableReviewTypes) => {
                setReviewTypes(availableReviewTypes ?? defaultArray);
                setLoading(false);
            },
            () => {
                setReviewTypes(defaultArray);
                setLoadFailed(true);
                setLoading(false);
            }
        );
    }, [selectedEmployeeId]);

    const options = reviewTypes.map((reviewType) => ({ id: reviewType.reviewTypeId, name: reviewType.reviewTypeName }));

    let message = null;

    if (loadFailed) {
        message = loadFailedMessage;
    } else if (!loading && options.length === 0) {
        message = noReviewTypesMessage;
    }

    return (
        <div className="new-review-modal-step">
            <ShowHide
                evaluator={message == null}
                show={(
                    <FormSelect
                        id="new-review-type"
                        loading={loading}
                        headingText={reviewTypeHeading}
                        placeholder="Choose a review type"
                        items={options}
                        selectedValue={selectedReviewTypeId}
                        onItemSelect={(item) => onSelectedReviewTypeChange(item.id)}
                    />
                )}
                hide={(
                    <>
                        {/* The heading belongs to the select this branch replaces, so it is repeated to keep the step labelled. */}
                        <h4>{reviewTypeHeading}</h4>
                        <FormHelperText danger={loadFailed}>{message}</FormHelperText>
                    </>
                )}
            />
        </div>
    );
}

ReviewTypeStep.propTypes = {
    selectedEmployeeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    selectedReviewTypeId: PropTypes.number,
    onSelectedReviewTypeChange: PropTypes.func.isRequired
};
